"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CustomSelectListModal = _interopRequireDefault(require("../CustomSelectListModal"));
var _default = exports.default = {
  name: 'CustomSelectSpecModal',
  // 选择货品模态框组件
  components: {
    CustomSelectListModal: _CustomSelectListModal.default
  },
  props: {
    ..._CustomSelectListModal.default.props,
    rowKey: {
      type: String,
      default: 'specId'
    },
    // 旺店通货品SKU查询接口
    method: {
      type: Function,
      required: true
    },
    // 获取列表的请求参数
    params: {
      type: Object,
      default: () => {}
    },
    // 旺店通货品品牌查询接口
    getWdtGoodsBrandMethod: {
      type: Function,
      required: true
    },
    // 按钮和模态框的标题
    modalTitle: {
      type: String,
      default: '添加货品'
    }
  },
  data() {
    return {
      valid: false,
      selectedRowKeys: '' // 已从数组转成字符串，多个之间用英文逗号分隔
    };
  },
  watch: {
    selectedRowKeys: {
      handler(val) {
        this.$emit('input', val);
      },
      immediate: true
    },
    valid: {
      handler(val) {
        this.$emit('update:valid', val);
      },
      immediate: true
    }
  },
  methods: {
    /**
     * @description: 生成columns
     * @param {number} type 1-选择货品模态框 0-已选中的货品列表
     * @return {*}
     */
    createColumns(type) {
      return [{
        title: '规格编码',
        dataIndex: 'specNo',
        width: 150,
        isSearch: type === 1
      }, ...this.createEditColumns(type), {
        title: '货品名称',
        dataIndex: 'goodsName',
        width: 200,
        isSearch: type === 1
      }, {
        title: '规格名称',
        dataIndex: 'specName',
        width: 200,
        isSearch: type === 1
      }, {
        title: '品牌',
        dataIndex: 'brandName',
        width: 150,
        isSearch: type === 1,
        searchProps: {
          dataIndex: 'brandId',
          valueType: 'infiniteSelect',
          fieldProps: {
            replaceFields: {
              value: 'brandId',
              label: 'brandName'
            },
            method: this.getWdtGoodsBrandMethod
          }
        }
      }, {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        align: 'center',
        width: 80,
        scopedSlots: {
          customRender: 'operation'
        },
        sort: false,
        show: () => type === 0
      }];
    },
    // 自动构建可编辑的表格列
    createEditColumns(type) {
      const editableColumns = _.cloneDeep(this.editableColumns);
      const arr = editableColumns.map(item => {
        return {
          ...item,
          dataIndex: item.dataIndex,
          title: item.title,
          width: item.width || 150,
          scopedSlots: {
            customRender: item.dataIndex
          },
          sort: false,
          show: () => !_.isEmpty(item) && type === 0
        };
      });
      return arr;
    },
    // 表格中内容发生变化
    handleChange({
      selectedRowKeys,
      selectedRows,
      valid
    }) {
      this.$emit('change', {
        selectedRowKeys,
        selectedRows,
        valid
      });
    }
  }
};